module.exports = ".text-post-row {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  height: 423px;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  font-size: 2.2rem; }\n  @media screen and (max-width: 767px) {\n    .text-post-row {\n      font-size: 1.9rem; } }\n\n.title {\n  font-size: 6.5rem; }\n  @media screen and (max-width: 767px) {\n    .title {\n      font-size: 4rem; } }\n"


//////////////////
// WEBPACK FOOTER
// ./src/angular-framework-client-components/components/text-post/text-post.style.scss
// module id = 798
// module chunks = 2